import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const EligibilitySlider = () => {
  const criteria = [
    {
      icon: "fas fa-university",
      title: "Bank Account",
      text: "An active bank account should be present."
    },
    {
      icon: "fas fa-users",
      title: "Income",
      text: "Applicant should be earning a regular income of ₹30K/month or above."
    },
    {
      icon: "fas fa-credit-card",
      title: "Credit Score",
      text: "Maintain a good credit score of more than 700*."
    },
    {
      icon: "fas fa-child",
      title: "Age",
      text: "The age limit for applying for a loan is 23 years – 58 years."
    },
    {
      icon: "fas fa-gavel",
      title: "Residency",
      text: "The applicant must be a legal resident of India."
    },
    {
      icon: "fas fa-address-card",
      title: "Permanent Address",
      text: "A permanent residential address with minimum 6 months stability is required."
    }
  ];

  // Split into groups of 2 per slide
  const grouped = [];
  for (let i = 0; i < criteria.length; i += 3) {
    grouped.push(criteria.slice(i, i + 3));
  }

  return (
    <section className="py-5" style={{ background: "#f4f6f9" }}>
      <div className="container text-center">

         <div className="text-center mb-5">
           

          <h2 className="fw-bold    d-inline-block px-4 py-2 mb-3"  style={{color:'#000'}} >
            Personal Loans Eligibility
          </h2>

          <p className="text-muted mx-auto" style={{ maxWidth: "850px" }}>
            Finbasket processes loan applications and delivers financial services in accordance with the guidelines and regulations of the Government of India. Eligibility criteria may differ from one bank or NBFC to another. However, the following are the basic minimum requirements typically considered by most financial institutions when evaluating personal loan applications.
          </p>
        </div>

        <div
          id="eligibilityCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000"
          data-bs-pause="false"
        >
          <div className="carousel-inner">

            {grouped.map((group, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                <div className="row justify-content-center">

                  {group.map((item, i) => (
                    <div key={i} className="col-md-3 mb-4">

                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                        style={{
                          width: "120px",
                          height: "120px",
                          background: "linear-gradient(135deg, rgb(21 186 211), rgb(67 130 146))",
                          color: "#fff",
                          fontSize: "35px"
                        }}
                      >
                        <i className={item.icon}></i>
                      </div>

                      <h5 className="fw-bold">{item.title}</h5>
                      <p className="text-muted">{item.text}</p>

                    </div>
                  ))}

                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
};

export default EligibilitySlider;